/**
 * AppStoreShotSocial · iter r97a · User M1517
 *
 * Screenshot statico 1290×2796 (iPhone 15/16 Pro Max) per App Store Connect —
 * mimica esatta dello stile della slide "La tua vetrina sul telefono dei
 * clienti" già caricata su App Store Connect, ma con testo + contenuto
 * dedicato ai CONTENUTI SOCIAL (post/reel/story/carosello Instagram).
 *
 * Iter r97a: sostituiti i 4 mini-tile anonimi del vecchio HeroSocialMockup
 * con i DUE visual d'impatto usati nell'email di lancio agenzie
 * (`social-open-house.v4.jpg` + `social-reel-poster.v4.moderno.jpg`).
 * Massima leggibilità e coerenza con la comunicazione già lanciata.
 *
 * Route: /promo/app-store-shot-social
 * Screenshot Playwright: 1290×2796 viewport → PNG salvato in /public/promo/.
 */
import React from "react";
import IPhone17ProFrame from "@/components/IPhone17ProFrame";

// Colore verde salvia — stesso della slide vetrina originale su App Store Connect
const SAGE_BG = "#7C8B6E";
// Tinta bianca leggermente scurita per il sottotitolo (come nell'originale)
const SUB_WHITE = "rgba(255,255,255,0.85)";

function ChevronArrow({ direction = "left", size = 42 }) {
  const rotate = direction === "left" ? 180 : 0;
  return (
    <svg
      width={size}
      height={size * 2}
      viewBox="0 0 24 48"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transform: `rotate(${rotate}deg)` }}
      aria-hidden="true"
    >
      <polyline points="8,12 18,24 8,36" />
    </svg>
  );
}

/** Contenuto interno all'iPhone: POST 1:1 grande + REEL 9:16 sotto + riga social. */
function SocialContentMockup() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "#FAF7F0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "48px",
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingBottom: "16px",
        boxSizing: "border-box",
        overflow: "hidden",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Header agenzia mini — coerente col brand Nova Casa dell'email */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: "6px",
          paddingRight: "6px",
          marginBottom: "10px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <div
            style={{
              width: "22px",
              height: "22px",
              borderRadius: "50%",
              background: "#7C8B6E",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "10px",
              color: "white",
              fontWeight: 700,
            }}
          >
            N
          </div>
          <div
            style={{
              fontSize: "10px",
              fontWeight: 600,
              color: "#1C1C1A",
              letterSpacing: "0.02em",
            }}
          >
            novacasa.milano
          </div>
        </div>
        <div
          style={{
            fontSize: "9px",
            color: "#8A8A80",
            letterSpacing: "0.1em",
            fontWeight: 500,
          }}
        >
          VETRINA SOCIAL
        </div>
      </div>

      {/* POST 1:1 Open House · visual pixel-identico all'email di lancio */}
      <div style={{ width: "100%", position: "relative" }}>
        <img
          src="/landing/social-open-house.v4.jpg"
          alt="Post Instagram Open House Trilocale Brera"
          style={{
            width: "100%",
            aspectRatio: "1 / 1",
            objectFit: "cover",
            borderRadius: "10px",
            display: "block",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "8px",
            left: "8px",
            background: "rgba(0,0,0,0.72)",
            color: "white",
            fontSize: "8px",
            fontWeight: 700,
            letterSpacing: "0.12em",
            padding: "3px 8px",
            borderRadius: "999px",
          }}
        >
          POST · 1:1
        </div>
      </div>

      {/* Etichetta sotto post */}
      <div
        style={{
          marginTop: "10px",
          fontSize: "9px",
          letterSpacing: "0.24em",
          fontWeight: 600,
          color: "#5A6250",
        }}
      >
        OPEN HOUSE · SABATO 15 MARZO
      </div>

      {/* REEL 9:16 · visual pixel-identico all'email di lancio */}
      <div
        style={{
          marginTop: "14px",
          display: "flex",
          gap: "10px",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Thumb reel */}
        <div style={{ position: "relative", flexShrink: 0 }}>
          <img
            src="/landing/social-reel-poster.v4.moderno.jpg"
            alt="Reel Instagram Restyling Trilocale Brera"
            style={{
              width: "72px",
              height: "128px",
              objectFit: "cover",
              borderRadius: "8px",
              display: "block",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "6px",
              left: "6px",
              background: "rgba(0,0,0,0.72)",
              color: "white",
              fontSize: "7px",
              fontWeight: 700,
              letterSpacing: "0.12em",
              padding: "2px 6px",
              borderRadius: "999px",
            }}
          >
            REEL · 9:16
          </div>
          {/* Play icon center */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.92)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#1C1C1A">
              <polygon points="6,4 20,12 6,20" />
            </svg>
          </div>
        </div>

        {/* Descrizione reel */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: "10px",
              fontWeight: 700,
              color: "#1C1C1A",
              marginBottom: "3px",
              letterSpacing: "-0.005em",
            }}
          >
            Restyling · Trilocale Brera
          </div>
          <div
            style={{
              fontSize: "8.5px",
              color: "#6B6B60",
              lineHeight: 1.35,
              marginBottom: "5px",
            }}
          >
            Video verticale con prima→dopo, musica e testi generati automaticamente.
          </div>
          <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
            {["#brera", "#restyling", "#milano"].map((t) => (
              <div
                key={t}
                style={{
                  fontSize: "7.5px",
                  color: "#7C8B6E",
                  fontWeight: 600,
                  background: "rgba(124,139,110,0.10)",
                  padding: "2px 6px",
                  borderRadius: "999px",
                }}
              >
                {t}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Riga "PUBBLICA SU" con icone social */}
      <div
        style={{
          marginTop: "auto",
          paddingTop: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <div
          style={{
            fontSize: "9px",
            fontWeight: 600,
            letterSpacing: "0.20em",
            color: "#8A8A80",
          }}
        >
          PUBBLICA SU
        </div>
        {/* Instagram */}
        <div
          style={{
            width: "22px",
            height: "22px",
            borderRadius: "6px",
            background: "linear-gradient(135deg, #F58529 0%, #DD2A7B 50%, #8134AF 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.5" cy="6.5" r="0.9" fill="white" />
          </svg>
        </div>
        {/* Facebook */}
        <div
          style={{
            width: "22px",
            height: "22px",
            borderRadius: "50%",
            background: "#1877F2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
            <path d="M13.5 22v-8h2.7l.4-3.1h-3.1V8.9c0-.9.3-1.5 1.6-1.5h1.7V4.6c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.1H7.4V14h2.6v8h3.5z" />
          </svg>
        </div>
        {/* WhatsApp */}
        <div
          style={{
            width: "22px",
            height: "22px",
            borderRadius: "50%",
            background: "#25D366",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
            <path d="M17.5 14.4c-.3-.1-1.6-.8-1.8-.9-.2-.1-.4-.1-.6.1-.2.2-.7.9-.8 1-.2.2-.3.2-.5.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5.1-.1.2-.3.2-.4.1-.2 0-.3 0-.5-.1-.1-.6-1.5-.8-2-.2-.5-.4-.5-.6-.5H8c-.2 0-.5.1-.7.3-.2.2-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3 4.8 4.2.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.6-.7 1.8-1.3.2-.6.2-1.2.2-1.3-.1-.1-.3-.2-.5-.3z" />
            <path d="M20.5 3.5C18.2 1.2 15.2 0 12 0 5.4 0 0 5.4 0 12c0 2.1.5 4.1 1.6 5.9L0 24l6.3-1.6c1.7.9 3.7 1.4 5.7 1.4C18.6 23.8 24 18.4 24 11.8c0-3.1-1.3-6.1-3.5-8.3zM12 21.8c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4C2.5 15.5 2 13.8 2 12 2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 9.8-10 9.8z" />
          </svg>
        </div>
        {/* TikTok */}
        <div
          style={{
            width: "22px",
            height: "22px",
            borderRadius: "50%",
            background: "#0A0A0A",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg width="11" height="11" viewBox="0 0 24 24" fill="white">
            <path d="M19.6 5.8c-1.5-.2-2.8-1.2-3.4-2.6-.2-.4-.3-.8-.3-1.2h-3.3v13.7c-.1 1.5-1.3 2.7-2.8 2.7-.9 0-1.7-.4-2.2-1-.6-.7-.8-1.6-.5-2.5.4-1.2 1.5-2 2.7-2 .3 0 .6 0 .8.1V9.7c-.3 0-.6-.1-.8-.1-3.2 0-5.9 2.6-5.9 5.9s2.6 5.9 5.9 5.9 5.9-2.6 5.9-5.9V9.2c1.3.9 2.9 1.4 4.5 1.4V7.3c-.2 0-.4 0-.6-.1z" />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default function AppStoreShotSocial() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,wght@1,400;1,500&family=Inter:wght@400;500;600;700&display=swap');
        html, body, #root { margin: 0; padding: 0; background: ${SAGE_BG}; }
        [data-testid="cookie-banner"], .cookie-banner, .CookieConsent,
        [class*="cookie"], [id*="cookie"], [class*="Cookie"] { display: none !important; }
      `}</style>

      {/* Canvas 1290 × 2796 · rapporto App Store Connect iPhone 15/16 Pro Max */}
      <div
        data-testid="app-store-shot-social"
        style={{
          width: "1290px",
          height: "2796px",
          background: SAGE_BG,
          position: "relative",
          overflow: "hidden",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {/* Titolo — split bold sans + italic serif (identico alla slide vetrina)
            iter r97b · User M1517: allineamento a sinistra come slide vetrina,
            sottotitolo piccolo CENTRATO su 1 riga, iPhone più vicino al testo. */}
        <div
          style={{
            paddingTop: "300px",
            paddingLeft: "150px",
            paddingRight: "150px",
            color: "white",
          }}
        >
          <div
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 700,
              fontSize: "116px",
              lineHeight: 0.95,
              letterSpacing: "-0.02em",
              marginBottom: "18px",
            }}
          >
            Contenuti social
          </div>
          <div
            style={{
              fontFamily: "'Bodoni Moda', serif",
              fontStyle: "italic",
              fontWeight: 500,
              fontSize: "108px",
              lineHeight: 0.95,
              letterSpacing: "-0.005em",
            }}
          >
            pronti per il feed
          </div>
        </div>

        {/* Sottotitolo piccolo CENTRATO — coerente con la slide vetrina */}
        <div
          style={{
            marginTop: "44px",
            width: "100%",
            textAlign: "center",
            fontFamily: "'Inter', sans-serif",
            fontWeight: 400,
            fontSize: "40px",
            lineHeight: 1.35,
            color: SUB_WHITE,
            letterSpacing: "-0.005em",
            paddingLeft: "150px",
            paddingRight: "150px",
            boxSizing: "border-box",
          }}
        >
          Post, reel, storie e caroselli in un tap.
        </div>

        {/* Frecce laterali navigazione — bianche, come nella slide vetrina */}
        <div style={{ position: "absolute", left: "45px", top: "50%", transform: "translateY(-50%)" }}>
          <ChevronArrow direction="left" size={70} />
        </div>
        <div style={{ position: "absolute", right: "45px", top: "50%", transform: "translateY(-50%)" }}>
          <ChevronArrow direction="right" size={70} />
        </div>

        {/* Mockup iPhone centrale · iter r97b: top 1080 per avvicinare l'iPhone
            al testo come nella slide vetrina originale. IPhone17ProFrame lg
            (400px) × 2.1 scaling. Il fondo iPhone viene naturalmente croppato
            dal canvas 2796 (identico alla slide vetrina già su App Store). */}
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "1080px",
            transform: "translateX(-50%) scale(2.1)",
            transformOrigin: "top center",
            width: "400px",
          }}
        >
          <IPhone17ProFrame size="lg" tone="titanium" showIsland={true} shadow={true}>
            <SocialContentMockup />
          </IPhone17ProFrame>
        </div>
      </div>
    </>
  );
}
